import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronDownMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronDownMedium"><Path d="M5.5 9.5L12 16L18.5 9.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronDownMedium;
